export const STORE_NAME = 'store';
export const LOCAL_STORAGE_NAMESPACE_PREFIX = 'cmc_onboarding';
export const REDUX_STATE_PERSIST_PART = 'persist';
export const LOCAL_STORAGE_DEBOUNCE_SAVE_IN_MS = 500;
